<template>
    <Card :bordered="false" class="border-radius-0">
        <Collapse v-model:activeKey="data.activeKey">
            <CollapsePanel
                v-for="child in childrenComputed"
                :key="`${child[4]}-${child[0].id}`"
                :header="`${child[4]}: ${child[0].id}: ${$t(`components.changeLog.type.${child[2]}`)}`"
            >
                <pre>{{ mapping({ child }) }}</pre>
            </CollapsePanel>
        </Collapse>
    </Card>
</template>

<script>
import { Card, Collapse } from "ant-design-vue";
import { computed, defineComponent, reactive } from "vue";
import { useRoute } from "vue-router";
import { state as stateApp } from "../../../app.logic";
import { onCallChangeLog } from "../../../utils/form";
import { createFormTitle, getChildren, initForm, mapping, state } from "./event.logic";

export default defineComponent({
    components: {
        Card,
        Collapse,
        CollapsePanel: Collapse.Panel
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: { default: false },
        form: {},
        setAppPageHeader: { default: true },
        visibleChangeLog: { default: true }
    },
    setup(props) {
        const route = useRoute();
        const id = props.form ? props.form.id : route.params?.id;
        const data = reactive({ rowProp: { gutter: 24 }, id });
        const refs = reactive({});
        initForm({ props, data, refs });
        const childrenComputed = computed(() => getChildren({ data }));
        const title = computed(() => createFormTitle({ data }));
        return {
            props,
            data,
            refs,
            state,
            title,
            childrenComputed,
            onCallChangeLog,
            mapping
        };
    }
});
</script>
